import ButtonGrouping from './ButtonGrouping';
import Checkbox from './Checkbox';
import CheckboxGroup from './CheckboxGroup';
import ConditionalRender from './ConditionalRender';
import DropdownDisplayList from './DropdownDisplayList';
import Feedback from './Feedback';
import Fieldset from './Fieldset';
import FileSelector from './FileSelector';
import Multiselect from './Multiselect';
import Numberbox from './Numberbox';
import PhoneNumber from './PhoneNumber';
import Textarea from './Textarea';
import Textbox from './Textbox';
import SearchSelect from './SearchSelect';
import SearchSelectbox from './SearchSelectbox';
import SelectBox from './SelectBox';


const FormControls = {
    ButtonGrouping,
    Checkbox,
    CheckboxGroup,
    ConditionalRender,
    DropdownDisplayList,
    Feedback,
    Fieldset,
    FileSelector,
    Multiselect,
    Numberbox,
    PhoneNumber,
    Textarea,
    Textbox,
    SearchSelect,
    SearchSelectbox,
    SelectBox
}
export {
    ButtonGrouping,
    Checkbox,
    CheckboxGroup,
    ConditionalRender,
    DropdownDisplayList,
    Feedback,
    Fieldset,
    FileSelector,
    Multiselect,
    Numberbox,
    PhoneNumber,
    Textarea,
    Textbox,
    SearchSelect,
    SearchSelectbox,
    SelectBox
};
export default FormControls;
